"use client";

import { Select, SelectItem } from "@kyan/ui";
import { useEffect } from "react";
import { Address } from "viem";

import { useAccounts } from "#/hooks/useAccounts";
import { useEoa } from "#/store/wallet/eoa/eoa";

import { InternalAccount } from "../InternalAccount/InternalAccount";

interface AccountSelectorProps {
  setAccount?: (account?: Address) => void;
  account?: Address;
}

export const AccountSelector: React.FC<AccountSelectorProps> = ({
  setAccount,
  account,
}) => {
  const { eoa } = useEoa();
  const { accounts } = useAccounts();

  useEffect(() => {
    if (account !== eoa) {
      setAccount?.(eoa);
    }
  }, [eoa, account, setAccount]);

  return (
    <Select
      value={account}
      disabled={Boolean(accounts.length < 2 && account)}
      triggerClassName="bg-white border-divider dark:bg-buttonBg"
      valueComponent={
        accounts.length && account ? (
          <InternalAccount
            address={account}
            index={accounts.findIndex(
              (smartAccount) => smartAccount === account,
            )}
          />
        ) : (
          "No account"
        )
      }
      onValueChange={setAccount}
    >
      {accounts.map((address, index) => (
        <SelectItem
          key={address}
          value={address}
          itemComponent={<InternalAccount index={index} address={address} />}
        />
      ))}
    </Select>
  );
};
